import { DeleteOutlined, PlusOutlined } from "@ant-design/icons"
import { Badge, Button, Flex, Typography } from "antd"
import React from "react"
import { useTranslation } from "react-i18next"

const { Text, Title } = Typography

interface TeamManagementHeaderProps {
  createAllowed?: boolean
  inviteAllowed?: boolean
  deletionRequestsAllowed?: boolean
  pendingDeletionCount?: number
  onInviteClick: () => void
  onDeletionRequestsClick?: () => void
}

export function TeamManagementHeader({
  createAllowed,
  inviteAllowed,
  deletionRequestsAllowed,
  pendingDeletionCount = 0,
  onInviteClick,
  onDeletionRequestsClick
}: TeamManagementHeaderProps) {
  const { t } = useTranslation()
  return (
    <Flex justify={"space-between"} wrap gap={"small"} align={"center"}>
      <Flex vertical>
        <Title className={"text-start"} level={2}>
          Team Management
        </Title>
        <Text type={"secondary"}>
          Manage users, roles, and project assignments.
        </Text>
      </Flex>
      <Flex gap={"middle"} align={"center"}>
        {deletionRequestsAllowed && (
          <Badge
            count={pendingDeletionCount}
            offset={pendingDeletionCount > 9 ? [-8, 2] : [-4, 2]}
            className="z-10"
          >
            <Button icon={<DeleteOutlined />} onClick={onDeletionRequestsClick}>
              {t("accountDeletionRequests.title")}
            </Button>
          </Badge>
        )}
        {(inviteAllowed || createAllowed) && (
          <Button
            type="primary"
            icon={<PlusOutlined />}
            onClick={onInviteClick}
          >
            User
          </Button>
        )}
      </Flex>
    </Flex>
  )
}
